(function () {
  var ESSYRO_CART_TIMER_KEY = 'essyro_cart_timer_deadline';
  var ESSYRO_CART_TIMER_COUNT_KEY = 'essyro_cart_timer_last_count';
  var ESSYRO_CART_TIMER_MINUTES = 15;
  var essyroIsEmpty = false;

  function essyroPad(n) {
    n = Math.max(0, n);
    return n < 10 ? '0' + n : String(n);
  }

  function essyroRenderClock() {
    var timerEl = document.getElementById('essyro-cart-timer');
    var clockEl = document.getElementById('essyro-cart-timer-clock');
    if (!timerEl || !clockEl) return;

    if (essyroIsEmpty) {
      timerEl.style.display = 'none';
      return;
    }

    timerEl.style.display = 'flex';

    var deadline = parseInt(localStorage.getItem(ESSYRO_CART_TIMER_KEY), 10);
    var now = new Date().getTime();

    if (!deadline || isNaN(deadline) || deadline <= now) {
      deadline = now + ESSYRO_CART_TIMER_MINUTES * 60 * 1000;
      localStorage.setItem(ESSYRO_CART_TIMER_KEY, deadline);
    }

    var diff = deadline - now;
    if (diff <= 0) {
      clockEl.textContent = '00:00';
      return;
    }

    var minutes = Math.floor(diff / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);
    clockEl.textContent = essyroPad(minutes) + ':' + essyroPad(seconds);
  }

  function essyroCheckCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var itemCount = cart.item_count;
        var lastCount = parseInt(localStorage.getItem(ESSYRO_CART_TIMER_COUNT_KEY), 10);
        if (isNaN(lastCount)) lastCount = null;

        var storedDeadline = parseInt(localStorage.getItem(ESSYRO_CART_TIMER_KEY), 10);
        var hasValidDeadline = !isNaN(storedDeadline) && storedDeadline > new Date().getTime();

        if (itemCount === 0) {
          localStorage.removeItem(ESSYRO_CART_TIMER_KEY);
        } else if (lastCount === 0 || lastCount === null || !hasValidDeadline) {
          // Cart just went from empty to having items (or this is a fresh session):
          // start a brand new 15-minute countdown.
          var freshDeadline = new Date().getTime() + ESSYRO_CART_TIMER_MINUTES * 60 * 1000;
          localStorage.setItem(ESSYRO_CART_TIMER_KEY, freshDeadline);
        }

        localStorage.setItem(ESSYRO_CART_TIMER_COUNT_KEY, itemCount);
        essyroIsEmpty = itemCount === 0;
        essyroRenderClock();
      })
      .catch(function () {});
  }

  essyroCheckCart();
  setInterval(essyroRenderClock, 1000);
  setInterval(essyroCheckCart, 2000);
})();